export interface MenuOpenedEventDetail {
    menuElement: HTMLWcsComNavSubmenuElement;
}
export interface CategoryOpenedEventDetail {
    categoryElement: HTMLWcsComNavCategoryElement;
}
